import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { reviewApplicationFailed, reviewApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* reviewApplication(action) {
  try {
    const url = `${BACKEND_URL}/resources/applications/${action.payload}/review`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(reviewApplicationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(reviewApplicationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(reviewApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
